import { Environment } from './types'

export const localhostEnvironment: Environment = {
	// API
	API_URL: 'https://local.api.btdev.net',
	API_TIMEOUT: 60000,
	FIXED_API_URL: '',
	// App
	APP_NAME: 'MyBrandTrack (Local)',
	APP_VERSION: '3.0.0',
	COMPANY_NAME: 'Brandtrack',

	// Features
	ENABLE_POSTHOG: 'none',
	ENABLE_AMPLITUDE: 'none',

	// Other
	NODE_ENV: 'development',

	// Build type
	BUILD_TYPE: 'brandtrack',
}
